import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import MiCuentaPage from './pages/MiCuentaPage';
import FinanzasPage from './pages/FinanzasPage';
import FinanzasDebug from './pages/FinanzasDebug';
import SueldosAdminPage from './pages/SueldosAdminPage';
import AuditTemplatePage from './pages/AuditTemplatePage';
import ColaGestionPage from './pages/ColaGestionPage';

function AppContent() {
  const { user, loading, login, logout } = useAuth();


  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div className="spinner" />
        <span style={{ marginLeft: '0.5rem' }}>Cargando...</span>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/login" 
            element={
              user ? 
              <Navigate to="/dashboard" replace /> : 
              <Login onLogin={login} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              user ? 
              <Dashboard user={user} onLogout={logout} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/mi-cuenta" 
            element={
              user ? 
              <MiCuentaPage /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/finanzas" 
            element={
              user ? 
              <FinanzasPage /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/finanzas-debug" 
            element={<FinanzasDebug />}
          />
          <Route 
            path="/sueldos-admin" 
            element={
              user && user.role === 'admin' ? 
              <SueldosAdminPage /> : 
              <Navigate to="/dashboard" replace />
            } 
          />
          <Route
            path="/audit-template"
            element={
              user && ['admin', 'supervisor', 'operador'].includes(user.role) ?
              <AuditTemplatePage /> :
              <Navigate to="/dashboard" replace />
            }
          />
          <Route
            path="/cola-gestion"
            element={
              user && ['admin', 'supervisor'].includes(user.role) ?
              <ColaGestionPage /> :
              <Navigate to="/dashboard" replace />
            }
          />
          <Route
            path="/"
            element={<Navigate to={user ? "/dashboard" : "/login"} replace />}
          />
          <Route 
            path="*" 
            element={<Navigate to={user ? "/dashboard" : "/login"} replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;